module.exports = __webpack_public_path__ + "img/icon_comment_like.5e90bf43.svg";